import { ReactNode } from 'react'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import styled, { css } from 'styled-components'
import { COLOR } from 'src/constants/colors'

export type ButtonPropsType = {
  display?: string
  children?: ReactNode
  height?: string
  $bgColor?: string
  color?: string
  $border?: string
  disabled?: boolean
  fontFamily?: string
  $border_radius?: string
  width?: string
  $margin?: string
  $padding?: string
  className?: string
  $align_items?: string
  style?: Object
  media?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  option?:
    | 'bigDefault'
    | 'bigIconText'
    | 'modal_cancel'
    | 'location_play_sound'
    | 'location_wifi'
    | 'modal_ok'
  id?: string
  $playStatus?: string
  $tabIndex?: number
}

const Button = (props: ButtonPropsType) => {
  const { setMediaStyle, currentMedia } = useMediaQueryHook()

  const ButtonOptionStyle = {
    bigDefault: {
      display: 'inline-block',
      width: '100%',
      height: currentMedia === 'pc' ? '52px' : '48px',
      padding: '0 16px',
      align_items: 'unset',
    },
    bigIconText: {
      display: 'flex',
      width: '100%',
      height: '48px',
      padding: '0 16px',
      align_items: 'center',
    },
    modal_ok: {
      display: 'inline-block',
      width: '120px',
      height: '48px',
      padding: '0',
      align_items: 'unset',
    },
    modal_cancel: {
      display: 'inline-block',
      width: '120px',
      height: '48px',
      padding: '0',
      align_items: 'unset',
    },
    location_play_sound: {
      display: 'flex',
      width: setMediaStyle('194px'),
      height: '46px',
      padding: '0 15px',
      align_items: 'center',
    },
    location_wifi: {
      display: 'flex',
      width: setMediaStyle('194px'),
      height: '46px',
      padding: '0 15px',
      align_items: 'center',
    },
  }

  return (
    <ButtonWrap
      {...props}
      tabIndex={props.$tabIndex}
      disabled={props.disabled}
      onClick={props.onClick}
      display={props.option ? ButtonOptionStyle[props.option]?.display : props.display}
      width={props.option ? ButtonOptionStyle[props.option]?.width : props.width}
      height={props.option ? ButtonOptionStyle[props.option]?.height : props.height}
      $padding={props.option ? ButtonOptionStyle[props.option]?.padding : props.$padding}
      $align_items={
        props.option ? ButtonOptionStyle[props.option]?.align_items : props.$align_items
      }
    >
      {props.children}
    </ButtonWrap>
  )
}
export default Button

const ButtonWrap = styled.button<ButtonPropsType>`
  display: ${(props) => props?.display || 'inline-block'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height};
  min-height: ${(props) => props.height};
  border: ${(props) => props.$border || 'none'};
  background-color: ${(props) => props.$bgColor || COLOR.white};
  justify-content: ${(props) => props.display === 'flex' && 'space-between'};
  margin: ${(props) => props.$margin || '0 auto'};
  padding: ${(props) => props.$padding || '0'};
  cursor: ${(props) => (props.disabled ? 'unset' : 'pointer')};
  border-radius: ${(props) => props.$border_radius || '12px'};
  align-items: ${(props) => props.$align_items};
  font-family: 'NotoSansBold', serif !important;

  &:disabled {
    background-color: ${COLOR.black10};
  }

  > span {
    line-height: ${(props) => props.height};
  }

  ${(props) =>
    props.option === 'bigDefault' &&
    css`
      border-radius: 12px;
      -webkit-tap-highlight-color: rgba(63, 160, 102, 0.1);
      &:hover {
        background-color: ${COLOR.brand4};
      }
      &:disabled {
        background-color: ${COLOR.black10};
      }
    `}
  ${(props) =>
    props.option === 'bigIconText' &&
    css`
      border-radius: 12px;
      -webkit-tap-highlight-color: rgba(240, 240, 240, 0.1);
      &:hover {
        background-color: ${COLOR.black6};
      }
      &:disabled {
        background-color: ${COLOR.black10};
      }
    `}
  ${(props) =>
    props.option === 'location_play_sound' &&
    css`
      &:hover {
        ${props.$playStatus !== 'true' &&
        css`
          background-color: ${COLOR.brand4};
        `}
      }
      &:disabled {
        background-color: ${COLOR.black10};
      }
    `}
  ${(props) =>
    props.option === 'location_wifi' &&
    css`
      &:hover {
        background-color: #d9f4e9;
      }
      &:disabled {
        background-color: ${COLOR.white};
        border: 1px solid ${COLOR.black10};
      }
    `}
  ${(props) =>
    props.option === 'modal_ok' &&
    css`
      border-radius: 12px;
      -webkit-tap-highlight-color: rgba(63, 160, 102, 0.1);
      &:hover {
        background-color: ${COLOR.brand4};
      }
      &:disabled {
        background-color: ${COLOR.black10};
      }
    `}
  ${(props) =>
    props.option === 'modal_cancel' &&
    css`
      border-radius: 12px;
      -webkit-tap-highlight-color: rgba(240, 240, 240, 0.1);
      &:hover {
        background-color: #d9f4e9;
      }
    `}
`
